.input {
  transition: none;

  &:focus-within {
    outline: 1px solid var(--secondary-base);
    border-color: transparent;
  }

  &:focus-within + div > svg {
    color: var(--secondary-base);
  }
}

.dropdown {
  background: var(--base-white);
  box-shadow: var(--box-shadow-big-soft);
  border-radius: 8px;
  box-sizing: border-box;
  width: auto !important;
  min-width: 160px;
  max-width: 450px;
}

.options {
  /* Hide scrollbar for webkit browsers */
  &::-webkit-scrollbar {
    display: none;
  }
}
